class LottieHover {
  constructor(element) {
    this.element = element;
    element.parentElement.classList.add('initialized');
    this.isHovered = false;
    this.hasPlayed = false; // Prevents re-triggering the animation multiple times

    // Initialize Lottie animation
    this.animation = lottie.loadAnimation({
      container: this.element,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: this.element.dataset.lottiePath, // Get the path from the data attribute
    });

    // Detect mobile using screen width
    this.isMobile = window.innerWidth <= 768; // Adjust this breakpoint if needed

    // Use hover for desktop, Intersection Observer for mobile
    if (!this.isMobile) {
      this.addEventListeners();
    } else {
      this.addIntersectionObserver();
    }
  }

  addEventListeners() {
    this.element.addEventListener('mouseenter', () => this.playForward());
    this.element.addEventListener('mouseleave', () => this.playBackward());
  }

  addIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.playForward(); // Play animation when visible
          } else {
            this.playBackward(); // Reset animation when out of view
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is visible
    );

    observer.observe(this.element);
  }

  playForward() {
    this.isHovered = true;
    this.animation.setDirection(1); // Play forward
    this.animation.play();

    this.animation.addEventListener('complete', () => {
      if (this.isHovered) {
        this.animation.pause(); // Pause at the last frame
      }
    });
  }

  playBackward() {
    this.isHovered = false;
    this.animation.setDirection(-1); // Reverse the animation
    this.animation.play();
  }
  
  resetAnimation() {
    this.animation.stop(); // Stops and resets animation to frame 0
  }
}